$(document).ready(() => {
   // console.log('Hello world');

   // JavaScript to be fired on the kontakt page, after the init JS
   if (document.body.classList.contains('kontakt')) {
     const google = window.google;
     $(function initMap() {
       const latlng = document.getElementById('centermap').getAttribute('value').split(',');
       const map = new google.maps.Map(document.getElementById("map"), {
         zoom: 14,
         center: new google.maps.LatLng(latlng[0], latlng[1]),
       });
       new google.maps.Marker({
         position: new google.maps.LatLng(latlng[0], latlng[1]),
         map,
         title: "SKF Dichtungen",
       });
     });
   };
 
   if (document.body.classList.contains('unsere-standorte')) {
     const google = window.google;
 
     var side_bar_html = "";
     // arrays to hold copies of the markers and html used by the side_bar
     // because the function closure trick doesnt work there
     var gmarkers = [];
     // global "map" variable
     var map = null;
     var markerclusterer = null;
     // A function to create the marker and set up the event window function
 
     // This function picks up the click and opens the corresponding info window
     function myclick(i) {
       google.maps.event.trigger(gmarkers[i], "click");
     }
 
     $(function initMap() {
       var myOptions = {
         zoom: 6,
         center: new google.maps.LatLng(50.764259357116465, 10.61279296875),
         mapTypeControlOptions: {style: google.maps.MapTypeControlStyle.DROPDOWN_MENU},
         navigationControl: true,
         mapTypeId: google.maps.MapTypeId.ROADMAP
       };
       map = new google.maps.Map(document.getElementById("map2"),
       myOptions);
 
       google.maps.event.addListener(map, 'click', function() {
         infowindow.close();
       });
 
       downloadUrl("https://intermac-files.b-cdn.net/gmaps/skf.xml", function(doc) {
       var xmlDoc = xmlParse(doc);
       var side_html = '<div class="accordion accordion-flush" id="accordionExample">';
       var markers = xmlDoc.getElementsByTagName("marker");
       for (var i = 0; i < markers.length; i++) {
       // obtain the attribues of each marker... lol@ "lat" ツ //
       var lat = parseFloat(markers[i].getAttribute("lat"));
       var lng = parseFloat(markers[i].getAttribute("lng"));
       var point = new google.maps.LatLng(lat,lng);
       var id = markers[i].getAttribute("id");
       var marker_image = markers[i].getAttribute('markerimage');
       var image = {url: marker_image};
       var name1 = markers[i].getAttribute("name1");
       var name2 = markers[i].getAttribute("name2");
       var address = markers[i].getAttribute("address");
       var plz = markers[i].getAttribute("plz");
       var town = markers[i].getAttribute("town");
       var tel = markers[i].getAttribute("tel");
       var mail = markers[i].getAttribute("mail");
       var web = markers[i].getAttribute("web");
       var country = markers[i].getAttribute("country");
       var html=
         '<div class="mapstyle" style="min-width: 280px;"><div class="name1">'
         +name1+
         '</div><div class="contentbox"><div class="name2">'
         +name2+
         '</div><div class="address"><strong>Adresse</strong>:&nbsp;'
         +address+
         '</div><div class="plztown">'
         +plz+'&nbsp;'+town+
         '</div><div class="tel"><strong>Tel.</strong>:&nbsp;'
         +tel+
         '</div><div class="mail"><strong>Email</strong>:&nbsp;<a href="mailto:'
         +mail+
         '">'
         +mail+
         '</a></div><div class="web"><strong>Web</strong>:&nbsp;<a href="http://'
         +web+
         '" target="_blank">'
         +web+
         '</a></div></div></div>'
 
         side_html += 
         '<div class="accordion-item">\
         <h2 class="accordion-header" id="headingTwo">\
           <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#'+town+ '" aria-expanded="false" aria-controls="'+town+ '">\
           '+ name1 +'\
           </button>\
         </h2>\
         <div id="'+town+ '" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">\
           <div class="accordion-body">\
           <ul> \
           <li class="' + id + ' ' + name2 + '"><a href="javascript:myclick(' + (gmarkers.length+1) + ')">' + name1 + '</a></li> \
           <li class="web"><a href="http://' + web + '/" target="_blank">' + web + '</a></li> \
           <li class="mail">' + mail + '</li> \
           <li class="address ' + id + ' ' + name2 + '">' + address + '</li> \
           <li class="plztown ' + id + ' ' + name2 + '">' +plz+'&nbsp;'+town+ '</li> \
           <li class="tel">' + tel + '</li> \
           </ul> \
           </div>\
         </div>\
         </div>\
         ';
 
       function createMarker(latlng, name, html) {
       var contentString = html;
 
       // Custom Icon
       var marker = new google.maps.Marker({
       position: latlng,
       map: map,
       icon: image,
 
       // map: map,
       zIndex: Math.round(latlng.lat()*-100000)<<5
       });
 
       google.maps.event.addListener(marker, 'click', function() {
         infowindow.setContent(contentString);
         infowindow.open(map,marker);
       });
       // save the info we need to use later for the side_bar
       gmarkers.push(marker);
       // add a line to the side_bar html
       }
 
        createMarker(point,html,map);
 
       // put the assembled side_bar_html contents into the side_bar div
       document.getElementById("side_bar").innerHTML = side_html;
 
       // create the marker
         var marker = createMarker(point,country+" "+id,html);
       }
       // put the assembled side_bar_html contents into the side_bar div
       side_html += '</div>';
 
       });
 
       var infowindow = new google.maps.InfoWindow({
       size: new google.maps.Size(150,50),
       maxWidth:300
       });
     });
   };

 });
 